import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { API } from "../api/auth";
import { useAuth } from "../context/AuthContext";
import PublicNav from "../components/PublicNav";

const C = {
  green:    "#006B3C",
  greenDk:  "#004D2B",
  greenLt:  "#E8F5EE",
  greenMid: "#00894D",
  yellow:   "#FFC300",
  yellowLt: "#FFF8DC",
  white:    "#FFFFFF",
  gray:     "#F5F5F5",
  grayBd:   "#E0E0E0",
  text:     "#1A1A1A",
  textSub:  "#666666",
};

const MailIcon   = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><rect x="1" y="3" width="14" height="10" rx="2" stroke={C.textSub} strokeWidth="1.5"/><path d="M1 6l7 4 7-4" stroke={C.textSub} strokeWidth="1.5"/></svg>;
const PhoneIcon  = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M3 1h4l1.5 4-2 1.2a9.1 9.1 0 004.3 4.3L12 8.5 16 10v4a2 2 0 01-2 2A15 15 0 011 3a2 2 0 012-2z" stroke={C.textSub} strokeWidth="1.5" strokeLinejoin="round"/></svg>;
const LockIcon   = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><rect x="3" y="7" width="10" height="8" rx="2" stroke={C.textSub} strokeWidth="1.5"/><path d="M5 7V5a3 3 0 016 0v2" stroke={C.textSub} strokeWidth="1.5"/></svg>;
const EyeIcon    = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M1 8s2.5-5 7-5 7 5 7 5-2.5 5-7 5-7-5-7-5z" stroke={C.textSub} strokeWidth="1.5"/><circle cx="8" cy="8" r="2" stroke={C.textSub} strokeWidth="1.5"/></svg>;
const EyeOffIcon = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M2 2l12 12M6.5 6.6A2 2 0 0010 10M4 4.3C2.4 5.4 1 8 1 8s2.5 5 7 5c1.4 0 2.7-.4 3.8-1M7 3.1C7.3 3 7.6 3 8 3c4.5 0 7 5 7 5s-.6 1.2-1.6 2.3" stroke={C.textSub} strokeWidth="1.5" strokeLinecap="round"/></svg>;
const AlertIcon  = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none" style={{ flexShrink:0 }}><circle cx="8" cy="8" r="7" stroke="#f87171" strokeWidth="1.5"/><path d="M8 5v4M8 11v.5" stroke="#f87171" strokeWidth="1.5" strokeLinecap="round"/></svg>;
const SpinIcon   = () => <span style={{ display:"inline-block", width:14, height:14, border:"2px solid rgba(255,255,255,0.35)", borderTopColor:"white", borderRadius:"50%", animation:"setrag-spin 0.6s linear infinite", marginRight:8, verticalAlign:"middle" }} />;
const TrainIcon  = () => <svg width="32" height="32" viewBox="0 0 24 24" fill="none"><rect x="4" y="3" width="16" height="13" rx="2" stroke="currentColor" strokeWidth="1.6"/><path d="M4 10h16M8 16l-2 4M16 16l2 4M9 10V6M15 10V6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><circle cx="8.5" cy="13.5" r="1" fill="currentColor"/><circle cx="15.5" cy="13.5" r="1" fill="currentColor"/></svg>;

const PanelLeft = () => (
  <div style={s.panel} className="setrag-panel">
    <style>{panelCSS}</style>
    <svg style={s.panelBg} viewBox="0 0 440 700" preserveAspectRatio="xMidYMid slice">
      <defs>
        <pattern id="rail-grid" width="44" height="44" patternUnits="userSpaceOnUse">
          <path d="M 44 0 L 0 0 0 44" fill="none" stroke="rgba(255,255,255,0.04)" strokeWidth="0.6"/>
        </pattern>
      </defs>
      <rect width="440" height="700" fill="url(#rail-grid)"/>
      <circle cx="80"  cy="160" r="180" fill="rgba(255,195,0,0.04)"/>
      <circle cx="360" cy="560" r="160" fill="rgba(255,195,0,0.05)"/>
      <g opacity="0.12">
        <line x1="60"  y1="0"   x2="60"  y2="700" stroke="#FFC300" strokeWidth="1.5"/>
        <line x1="100" y1="0"   x2="100" y2="700" stroke="#FFC300" strokeWidth="1.5"/>
        {[80,160,240,320,400,480,560,640].map(y => (
          <line key={y} x1="52" y1={y} x2="108" y2={y} stroke="#FFC300" strokeWidth="3"/>
        ))}
      </g>
      <g opacity="0.07">
        <line x1="340" y1="0"   x2="340" y2="700" stroke="#FFC300" strokeWidth="1.2"/>
        <line x1="370" y1="0"   x2="370" y2="700" stroke="#FFC300" strokeWidth="1.2"/>
        {[60,140,220,300,380,460,540,620].map(y => (
          <line key={y} x1="333" y1={y} x2="377" y2={y} stroke="#FFC300" strokeWidth="2.5"/>
        ))}
      </g>
      <circle cx="220" cy="350" r="90"  fill="none" stroke="rgba(255,195,0,0.08)" strokeWidth="0.8"/>
      <circle cx="220" cy="350" r="150" fill="none" stroke="rgba(255,195,0,0.05)" strokeWidth="0.8"/>
    </svg>

    <div style={s.panelContent}>
      <div style={s.panelLogo}>
        <span style={{ color:C.yellow, marginRight:10 }}><TrainIcon /></span>
        <div>
          <div style={{ fontWeight:800, fontSize:22, letterSpacing:2 }}>SETRAG</div>
          <div style={{ fontSize:10, color:"rgba(255,255,255,0.5)", letterSpacing:3 }}>TRANSGABONAIS</div>
        </div>
      </div>

      <div style={{ margin:"auto 0" }}>
        <div style={{ display:"inline-block", background:"rgba(255,195,0,0.15)", border:"1px solid rgba(255,195,0,0.3)", borderRadius:20, padding:"4px 14px", fontSize:11, color:C.yellow, marginBottom:18, letterSpacing:1 }}>
          🇬🇦 Gabon · Depuis 1987
        </div>
        <h2 style={s.panelTitle}>Bon retour à bord !</h2>
        <p style={s.panelSub}>
          Connectez-vous pour accéder à vos billets, gérer vos réservations et voyager à travers le Gabon en toute sérénité.
        </p>
      </div>

      <div style={s.panelQuoteBlock}>
        <div style={{ width:3, borderRadius:2, background:C.yellow, flexShrink:0, minHeight:36 }} />
        <p style={s.panelQuote}>
          "Plus de 9 000 trajets effectués en toute confiance à travers le Transgabonais."
        </p>
      </div>

      <div style={s.panelStats}>
        {[["9 204","Trajets"],["138","Transporteurs"],["4.8★","Note moy."]].map(([v, l]) => (
          <div key={l} style={{ textAlign:"center" }}>
            <div style={s.statVal}>{v}</div>
            <div style={s.statLabel}>{l}</div>
          </div>
        ))}
      </div>

      <div style={{ marginTop:24, paddingTop:20, borderTop:"1px solid rgba(255,255,255,0.08)" }}>
        <div style={{ fontSize:10, color:"rgba(255,255,255,0.35)", letterSpacing:1.5, marginBottom:10, textTransform:"uppercase" }}>La ligne</div>
        <div style={{ display:"flex", alignItems:"center", gap:2, overflowX:"auto" }}>
          {["LBV","OWD","NTM","BFN","LPÉ","BOÉ","FCV"].map((st, i, arr) => (
            <React.Fragment key={st}>
              <div style={{ textAlign:"center", flexShrink:0 }}>
                <div style={{ width:6, height:6, borderRadius:"50%", background:C.yellow, margin:"0 auto 3px" }} />
                <div style={{ fontSize:9, color:"rgba(255,255,255,0.45)", fontWeight:600 }}>{st}</div>
              </div>
              {i < arr.length-1 && <div style={{ flex:1, height:1, background:"rgba(255,195,0,0.3)", minWidth:8 }} />}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  </div>
);

const Field = ({ label, icon, error, ...inputProps }) => (
  <div style={{ marginBottom:16 }}>
    <label style={s.label}>{label}</label>
    <div style={{ position:"relative" }}>
      <span style={s.inputIcon}>{icon}</span>
      <input style={{ ...s.input, borderColor: error ? "#f87171" : undefined, paddingLeft:42 }} {...inputProps} />
    </div>
    {error && <div style={s.fieldError}>{error}</div>}
  </div>
);

const Login = () => {
  const navigate  = useNavigate();
  const { login } = useAuth();

  const [email,    setEmail]    = useState("");
  const [authMethod, setAuthMethod] = useState("email"); // "email" | "phone" - juste pour adapter le libellé/placeholder
  const [password, setPassword] = useState("");
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState("");
  const [showPwd,  setShowPwd]  = useState(false);

  const handleLogin = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await axios.post(API.LOGIN, { email, password });
      const userData = await login(res.data.token, res.data.refresh_token);
      const roles = userData?.roles ?? [];
      if (roles.includes("ROLE_ADMIN"))      return navigate("/admin",          { replace: true });
      if (roles.includes("ROLE_AGENT"))      return navigate("/agent",          { replace: true });
      if (roles.includes("ROLE_PROGRAMMER")) return navigate("/programmer",     { replace: true });
      if (roles.includes("ROLE_CONTROLLER")) return navigate("/admin/scan",     { replace: true });
      if (roles.includes("ROLE_SUPPORT"))    return navigate("/admin/messages", { replace: true });
      navigate("/dashboard", { replace: true });
    } catch {
      setError(authMethod === "email" ? "Email ou mot de passe incorrect." : "Téléphone ou mot de passe incorrect.");
    } finally {
      setLoading(false);
    }
  };

  const handleKey = (e) => e.key === "Enter" && handleLogin();

  return (
    <>
      <PublicNav />
      <div style={s.page}>
        <style>{globalCSS}</style>
        <PanelLeft />

        <div style={s.formSide}>
        <div style={s.formBox}>
          <div style={s.formHeader}>
            <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:20 }}>
              <div style={{ width:36, height:36, borderRadius:10, background:C.greenLt, display:"flex", alignItems:"center", justifyContent:"center" }}>
                <span style={{ color:C.green }}><TrainIcon /></span>
              </div>
              <div>
                <div style={{ fontWeight:800, fontSize:15, color:C.green, letterSpacing:1 }}>SETRAG</div>
                <div style={{ fontSize:10, color:C.textSub, letterSpacing:2 }}>TRANSGABONAIS</div>
              </div>
            </div>
            <h1 style={s.formTitle}>Connexion</h1>
            <p style={s.formSub}>
              Pas encore de compte ?{" "}
              <Link to="/register" style={s.link}>S'inscrire gratuitement</Link>
            </p>
          </div>

          {error && (
            <div style={s.errorBox}>
              <AlertIcon />{error}
            </div>
          )}

          <div style={{ marginBottom:14 }}>
            <label style={s.label}>Je me connecte avec</label>
            <div style={{ display:"flex", gap:8 }}>
              {[["email","Mon email"],["phone","Mon téléphone"]].map(([val,lbl]) => (
                <button key={val} type="button" onClick={() => { setAuthMethod(val); setEmail(""); }}
                  style={{
                    flex:1, padding:"9px 12px", borderRadius:10, fontWeight:700, fontSize:13, cursor:"pointer",
                    border:`1.5px solid ${authMethod===val ? C.green : C.grayBd}`,
                    background: authMethod===val ? C.greenLt : "#fff",
                    color: authMethod===val ? C.green : C.textSub,
                  }}>
                  {authMethod===val && "✓ "}{lbl}
                </button>
              ))}
            </div>
          </div>

          <Field
            label={authMethod === "email" ? "Adresse email" : "Numéro de téléphone"}
            icon={authMethod === "email" ? <MailIcon /> : <PhoneIcon />}
            type={authMethod === "email" ? "email" : "tel"}
            placeholder={authMethod === "email" ? "vous@exemple.ga" : "074 00 00 00"}
            value={email}
            onChange={e => setEmail(e.target.value)}
            onKeyDown={handleKey}
            autoComplete="username"
          />

          <div style={{ marginBottom:8 }}>
            <label style={s.label}>Mot de passe</label>
            <div style={{ position:"relative" }}>
              <span style={s.inputIcon}><LockIcon /></span>
              <input
                style={{ ...s.input, paddingLeft:42, paddingRight:42 }}
                type={showPwd ? "text" : "password"}
                placeholder="••••••••"
                value={password}
                onChange={e => setPassword(e.target.value)}
                onKeyDown={handleKey}
                autoComplete="current-password"
              />
              <button style={s.eyeBtn} onClick={() => setShowPwd(!showPwd)} type="button">
                {showPwd ? <EyeOffIcon /> : <EyeIcon />}
              </button>
            </div>
          </div>

          <div style={{ textAlign:"right", marginBottom:28 }}>
            <Link to="/forgot" style={{ ...s.link, fontSize:12 }}>Mot de passe oublié ?</Link>
          </div>

          <button style={s.submitBtn} onClick={handleLogin} disabled={loading} className="setrag-btn">
            {loading ? <><SpinIcon />Connexion en cours…</> : "Se connecter"}
          </button>

          <div style={s.divider}><span style={s.dividerText}>ou</span></div>

          <div style={s.altLinks}>
            <Link to="/register" style={s.altBtn}>
              <span>🎟️</span> Créer un compte voyageur
            </Link>
            <Link to="/" style={{ ...s.altBtn, borderColor:C.green, color:C.green }}>
              <span>🚆</span> Rechercher un trajet
            </Link>
          </div>

          <p style={{ fontSize:11, color:C.textSub, textAlign:"center", marginTop:24, lineHeight:1.6 }}>
            En vous connectant, vous acceptez nos{" "}
            <Link to="/conditions" style={{ color:C.green }}>Conditions d'utilisation</Link>
          </p>
        </div>
      </div>
      </div>
    </>
  );
};

export default Login;

const s = {
  page:        { display:"flex", minHeight:"100vh", fontFamily:"'Segoe UI', sans-serif" },
  panel:       { width:"44%", background:C.greenDk, position:"relative", overflow:"hidden", flexShrink:0 },
  panelBg:     { position:"absolute", inset:0, width:"100%", height:"100%" },
  panelContent:{ position:"relative", zIndex:1, display:"flex", flexDirection:"column", height:"100%", padding:"36px 40px" },
  panelLogo:   { display:"flex", alignItems:"center", gap:8, color:"#fff", marginBottom:"auto" },
  panelTitle:  { fontSize:30, fontWeight:800, color:"#fff", letterSpacing:-0.5, lineHeight:1.2, marginBottom:12 },
  panelSub:    { fontSize:14, color:"rgba(255,255,255,0.55)", lineHeight:1.75 },
  panelQuoteBlock:{ display:"flex", alignItems:"flex-start", gap:14, margin:"32px 0" },
  panelQuote:  { fontSize:13, color:"rgba(255,255,255,0.45)", lineHeight:1.7, margin:0, fontStyle:"italic" },
  panelStats:  { display:"flex", gap:0, paddingTop:20, borderTop:"1px solid rgba(255,255,255,0.08)", justifyContent:"space-around" },
  statVal:     { fontSize:18, fontWeight:800, color:"#fff" },
  statLabel:   { fontSize:10, color:"rgba(255,255,255,0.4)", marginTop:2 },
  formSide:    { flex:1, display:"flex", alignItems:"center", justifyContent:"center", background:C.gray, padding:"40px 32px" },
  formBox:     { width:"100%", maxWidth:400 },
  formHeader:  { marginBottom:28 },
  formTitle:   { fontSize:26, fontWeight:800, color:C.text, margin:"0 0 6px", letterSpacing:-0.5 },
  formSub:     { fontSize:13, color:C.textSub, margin:0 },
  link:        { color:C.green, fontWeight:700, textDecoration:"none" },
  errorBox:    { display:"flex", alignItems:"center", gap:8, background:"#fff5f5", border:"1px solid #fecaca", borderRadius:10, padding:"10px 14px", marginBottom:20, fontSize:13, color:"#dc2626" },
  fieldError:  { fontSize:11, color:"#f87171", marginTop:4 },
  label:       { display:"block", fontSize:12, fontWeight:700, color:C.textSub, marginBottom:6, textTransform:"uppercase", letterSpacing:0.5 },
  input:       { width:"100%", padding:"12px 14px", border:`1.5px solid ${C.grayBd}`, borderRadius:10, fontSize:14, fontFamily:"inherit", color:C.text, background:"#fff", outline:"none", boxSizing:"border-box", transition:"border-color 0.15s" },
  inputIcon:   { position:"absolute", left:14, top:"50%", transform:"translateY(-50%)", display:"flex", alignItems:"center", pointerEvents:"none" },
  eyeBtn:      { position:"absolute", right:12, top:"50%", transform:"translateY(-50%)", background:"none", border:"none", cursor:"pointer", padding:4, display:"flex", alignItems:"center" },
  submitBtn:   { width:"100%", padding:"13px 0", background:`linear-gradient(135deg, ${C.green}, ${C.greenMid})`, color:"#fff", border:"none", borderRadius:10, fontSize:15, fontWeight:700, cursor:"pointer", fontFamily:"inherit", display:"flex", alignItems:"center", justifyContent:"center", gap:6, letterSpacing:0.3 },
  divider:     { position:"relative", textAlign:"center", margin:"22px 0", borderTop:`1px solid ${C.grayBd}` },
  dividerText: { position:"absolute", top:"50%", left:"50%", transform:"translate(-50%,-50%)", background:C.gray, padding:"0 12px", fontSize:11, color:C.textSub },
  altLinks:    { display:"flex", flexDirection:"column", gap:10 },
  altBtn:      { display:"flex", alignItems:"center", justifyContent:"center", gap:8, padding:"12px 0", border:`1.5px solid ${C.grayBd}`, borderRadius:10, fontSize:13, color:C.text, textDecoration:"none", fontWeight:600, background:"#fff", transition:"border-color 0.15s" },
};

const panelCSS = `@media (max-width: 768px) { .setrag-panel { display: none !important; } }`;
const globalCSS = `
  @keyframes setrag-spin { to { transform: rotate(360deg); } }
  input:focus { border-color: #006B3C !important; box-shadow: 0 0 0 3px rgba(0,107,60,0.1) !important; }
  .setrag-btn:hover:not(:disabled) { opacity: 0.9; transform: translateY(-1px); }
  .setrag-btn:disabled { opacity: 0.6; cursor: not-allowed; }
  .setrag-btn { transition: all 0.15s ease; }
  @media (max-width: 768px) { .setrag-panel { display: none !important; width: 0 !important; } }
`;